import { WarningOutlined } from '@ant-design/icons'
import { selectSelectedJob } from '@store/JobReducer'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { useAppSelector } from '@utils/hooks'
import { requiredRule } from '@utils/rules'
import { Form, Input, Result } from 'antd'
import { useEffect } from 'react'

const Delete = ({ form, formProps }: SBRMFormActionProps) => {
  const item = useAppSelector(selectSelectedJob())

  useEffect(() => {
    form.setFieldsValue(item)
  }, [item])

  if (!item) return <></>

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Result
        title="Êtes-vous de vouloir supprimer ?"
        icon={<WarningOutlined style={{ color: '#dc4446' }} />}
      />
      <Form.Item name="id" required rules={[requiredRule()]} className="d-none">
        <Input type="hidden" />
      </Form.Item>
    </Form>
  )
}

export default Delete
